module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/093-basque-country-3ce3b1255b0c4a0974542cba547b158c.svg";